import { render, staticRenderFns } from "./HotkeysModal.vue?vue&type=template&id=0543ac5f&scoped=true&"
import script from "./HotkeysModal.vue?vue&type=script&lang=js&"
export * from "./HotkeysModal.vue?vue&type=script&lang=js&"
import style0 from "./HotkeysModal.vue?vue&type=style&index=0&id=0543ac5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0543ac5f",
  null
  
)

export default component.exports